/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import Graph from "./Graph";
import { useEffect, useState } from "react";
import fetchHelper from "../../services/fetchHelper";
import Filter from "../../components/Filter";
import { useContext } from "react";
import { LayoutContext } from "../../components/layout";

const dData = require("./device-population.json");

const ISO = [
  { value: "PRELIMINARY", label: "PRELIMINARY" },
  { value: "TERMINATED", label: "REMOVED" },
  { value: "NOTASSIGNED", label: "NOTASSIGNED" },
  { value: "FINAL", label: "FINAL" },
];

const keys = [
  "Pacemaker30",
  "Pacemaker90",
  "CRT-D30",
  "CRT-P30",
  "ICD30",
  "ILR30",
  "CRT-D90",
  "CRT-P90",
  "ICD90",
  "ILR90",
];

const EnabledDevice = () => {
  const dd = ["OTHER", "BOSTONSCI", "BIOTRONIK", "STJUDE", "MEDTRONIC"];
  const { user } = useContext(LayoutContext);
  const [totalByKeys, setTotalByKeys] = useState({});
  const [data, setData] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({});

  useEffect(() => {
    if (user) setLocations([{ value: user?.locations[0]?.id, label: user?.locations[0]?.name }]);
    setListData(dData);
  }, [user]);

  useEffect(() => {
    fetchData();
  }, [filter]);

  useEffect(() => {
    const d = {};
    data.forEach((item) => {
      keys.forEach((key) => {
        d[key] = d[key] || 0;
        d[key] = d[key] + item[key];
      });
    });
    setTotalByKeys(d);
  }, [data]);

  const queryDateFormat = (date) => {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");

    return year + "-" + month + "-" + day;
  };

  const setListData = (data) => {
    const list = data.map((item) => {
      let sortVal = dd.indexOf(item.mfr);
      if (sortVal < 0) sortVal = 999;
      return {
        ...item,
        Pacemaker30: item.pacemaker30,
        Pacemaker90: item.pacemaker90 * -1,
        "CRT-D30": item.crtd30,
        "CRT-D90": item.crtd90 * -1,
        "CRT-P30": item.crtp30,
        "CRT-P90": item.crtp90 * -1,
        ICD30: item.icd30,
        ICD90: item.icd90 * -1,
        ILR30: item.ilr30,
        ILR90: item.ilr90 * -1,
        total: item.pacemaker + item.crtd + item.crtp + item.icd + item.ilr,
        sortVal,
      };
    });
    list.sort((a, b) => a.sortVal - b.sortVal);
    setData(list);
  };

  const fetchData = async () => {
    const { endDate: toDate, startDate: fromDate, where } = filter;
    if (!where) return false;
    const urlParams = {
      where: where,
    };
    if (fromDate) urlParams.fromDate = queryDateFormat(fromDate);
    if (toDate) urlParams.toDate = queryDateFormat(toDate);

    const urlQuery = new URLSearchParams(urlParams);
    setLoading(true);
    let url = "/patientmanagement/rest/interrogations/activePatientsDeviceRemoteCannedReport?" + urlQuery;
    // if (process.env.NODE_ENV === "development") url = "/jsons/device-population.json?" + urlQuery;

    try {
      const data = await fetchHelper.get({ url });
      setListData(data);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  // const fetchLocation = async () => {
  //   try {
  //     let url = "/patientmanagement/rest/location/serviceReport";
  //     //   if (process.env.NODE_ENV === "development") url = "/serviceReport.json";
  //     const res = await fetchHelper.get({ url });
  //     setLocations(res.map((i) => ({ value: i.id, label: i.name })));
  //   } catch (err) {
  //     setLocations([{ value: user?.locations[0]?.id, label: user?.locations[0]?.name }]);
  //   }
  // };

  const onChangeFilter = (data) => {
    setFilter({ ...data, temp: new Date().getTime() });
  };

  return (
    <div style={{ display: "flex", flex: 1 }}>
      <div style={{ display: "flex", width: 350 }}>
        <Filter
          key={locations.length + "filter"}
          onChange={onChangeFilter}
          loading={loading}
          fields={[
            { type: "line" },
            {
              type: "multiSelect",
              whereKey: "location.id",
              key: "location",
              operator: "$eq",
              label: "Location",
              options: locations,
              maxSelect: 1,
              forceHasSelectAll: false,
              initialSelected: [{ value: user?.locations[0]?.id }],
            },
          ]}
        />
      </div>
      <div style={{ display: "flex", flex: 1, padding: 10 }}>
        <Graph data={data} keys={keys} totalByKeys={totalByKeys} />
      </div>
    </div>
  );
};

export default EnabledDevice;
